<template>
  <div class="financeManage-transactionHold-page">
    <p class="hasBottomLine">基金管理</p>
    <div class="dialogHeader">
      <div class="header-seach-box">
        <div class="setDatePicker">
          <span class="setPading">项目名称</span>
          <el-select v-model="projectName" slot="prepend" placeholder="请选择">
            <el-option label="全部" value=""></el-option>
            <el-option :label="item" :value="item" v-for="item in nameList" :key="item"></el-option>
          </el-select>
        </div>

      </div>
      <div class="header-seach-box">
        <div class="setDatePicker">
          <span class="setPading">搜索时间</span>
          <el-date-picker v-model="serchStartTime" value-format="timestamp" type="datetime" placeholder="选择开始时间">
          </el-date-picker>
          <span class="setPading">至</span>
          <el-date-picker v-model="serchEndTime" value-format="timestamp" type="datetime" placeholder="选择结束时间">
          </el-date-picker>
        </div>

        <!-- <div class="inpuBox">
          <el-input v-model="projectName" placeholder="项目name"></el-input>
        </div> -->

        <div class="setDatePicker" style="margin-left:30px">
          <el-button type="primary" round @click="getPageListInfo()">搜索</el-button>
          <el-button type="success" round @click="clearSearh()">清空筛选条件</el-button>
          <el-button type="primary" round @click="addBtn()">新增</el-button>
        </div>

        <!-- <el-button type="success" class="toTransLfet" @click="editBtn({}, 'add')">添加方案</el-button> -->
      </div>
    </div>
    <el-table :data="NetValueInfo" style="width:99%">
      <el-table-column property="projectId" label="项目id"></el-table-column>
      <el-table-column property="projectName" label="项目名称"></el-table-column>
      <el-table-column property="createTime" width="180" label="创建时间">
        <template slot-scope="scope">
          <span> {{ scope.row.createTime | moment }}</span>
        </template>
      </el-table-column>
      <el-table-column property="showTime" width="180" label="显示时间">
        <template slot-scope="scope">
          <span> {{ scope.row.showTime | moment }}</span>
        </template>
      </el-table-column>
      <el-table-column property="increaseRate" label="增长率"></el-table-column>
      <el-table-column property="netValue" label="净值"></el-table-column>
      <el-table-column property="parentNetValue" label="母项目净值"></el-table-column>

      <!-- <el-table-column property="profitRate" label="盈亏率">
        <template slot-scope="scope">
          <span v-if="scope.row.profitRate < 0" style="color:red">{{ scope.row.profitRate }}</span>
          <span v-else style="color:#55A955">{{ scope.row.profitRate }}</span>
        </template>
      </el-table-column> -->

      <el-table-column prop="maxDay" label="操作" width="200">
        <template slot-scope="scope">
          <el-button type="primary" @click="showDetailBtn(scope.row)">修改</el-button>
        </template>
      </el-table-column>
    </el-table>
    <div class="footer-box">
      <el-pagination
        @size-change="sizeChange"
        @current-change="pageChange"
        :current-page.sync="currentPage"
        :page-size="pageSize"
        layout="total, prev, pager, next"
        :total="NetValueTotal"
      >
      </el-pagination>
    </div>

    <el-dialog title="修改" :visible.sync="showEdit" @close="closeDialog">
      <el-form label-width="150px" :model="editInfo">
        <el-form-item label="项目名称">
          <el-input v-model="editInfo.projectName" disabled="disabled"></el-input>
        </el-form-item>
        <el-form-item label="净值">
          <el-input v-model="editInfo.netValue"></el-input>
        </el-form-item>
        <el-form-item label="显示时间">
          <el-date-picker
            type="date"
            value-format="timestamp"
            placeholder="选择日期"
            v-model="editInfo.showTime"
            style="width: 100%;"
          ></el-date-picker>
        </el-form-item>
        <el-form-item>
          <el-button type="info" @click="closeDialog()">取消</el-button>
          <el-button type="primary" @click="saveEdit()">保存</el-button>
        </el-form-item>
      </el-form>
    </el-dialog>

    <el-dialog title="新增" :visible.sync="showaddDialog" @close="closeDialog">
      <el-form label-width="150px" :model="addInfo">
        <el-form-item label="项目名称">
          <el-select v-model="addInfo.projectName" placeholder="请选择">
            <el-option v-for="item in nameList" :key="item" :label="item" :value="item"> </el-option>
          </el-select>
        </el-form-item>
        <el-form-item label="净值">
          <el-input v-model="addInfo.netValue"></el-input>
        </el-form-item>
        <el-form-item label="显示时间">
          <el-date-picker
            type="date"
            value-format="timestamp"
            placeholder="选择日期"
            v-model="addInfo.showTime"
            style="width: 100%;"
          ></el-date-picker>
        </el-form-item>
        <el-form-item>
          <el-button type="info" @click="closeDialog()">取消</el-button>
          <el-button type="primary" @click="saveAdd()">保存</el-button>
        </el-form-item>
      </el-form>
    </el-dialog>
  </div>
</template>

<script>
import "./store";
import api from "./api";
import { mapActions, mapGetters, mapState } from "vuex";
export default {
  name: "raiseFunds",
  data() {
    return {
      serchStartTime: "",
      serchEndTime: "",
      currentPage: 1,
      pageSize: 10,
      serchDirection: "",
      serchStatus: "0",
      projectName: "",
      showEdit: false,

      editInfo: {},
      addInfo: {},
      showaddDialog: false,
      nameList: []
    };
  },
  computed: {
    ...mapState("RaiseFunds", ["NetValueTotal", "NetValueInfo"])
  },
  methods: {
    ...mapActions("RaiseFunds", ["getNetValueList"]),
    hanldSelectType() {
      this.serchInfo.selectCoin = "";
    },
    sizeChange(val) {},
    pageChange(val) {
      this.getPageListInfo();
    },
    showListBtn(row) {
      let that = this;
      this.showEdit = true;
      this.borrowCoinParam = row.borrowCoin;
      this.mortgageCoinParam = row.mortgageCoin;
      this.getPageListInfo();
    },
    getPageListInfo() {
      let postData = {
        page: this.currentPage,
        size: this.pageSize,
        endTime: this.serchEndTime,
        startTime: this.serchStartTime,
        projectName: this.projectName
      };
      this.getNetValueList(postData);
    },
    handleSearch() {},
    clearSearh() {
      this.serchStatus = "0";
      this.serchDirection = "";
      this.serchEndTime = "";
      this.serchStartTime = "";
      this.projectName = "";

      this.showaddDialog = false;
      this.showEdit = false;
      this.addInfo = {};
      this.getPageListInfo();
    },

    closeDialog() {
      this.showEdit = false;
      this.clearSearh();
    },

    showDetailBtn(row) {
      this.showEdit = true;
      this.editInfo = JSON.parse(JSON.stringify(row));
    },
    toGoDetailPage(id) {
      this.$router.push("/home/finance/manage/mortgage/orderDetail?id=" + id);
    },

    saveEdit() {
      let that = this;
      api
        .updateNetValue({
          id: Number(that.editInfo.id),
          netValue: that.editInfo.netValue,
          showTime: that.editInfo.showTime
        })
        .then(res => {
          console.log(res);
          that.getPageListInfo();
          that.$message.success(res.msg);
          that.clearSearh();
        });
    },

    addBtn() {
      this.showaddDialog = true;
    },

    saveAdd() {
      let that = this;
      api
        .addNetValue({
          projectName: that.addInfo.projectName,
          netValue: that.addInfo.netValue,
          showTime: that.addInfo.showTime
        })
        .then(res => {
          console.log("add", res);
          this.$message.success(res.msg);
          that.getPageListInfo();
          that.clearSearh();
        });
    }
  },
  created() {},
  mounted() {
    let that = this;
    this.getPageListInfo();

    api.projectNames({}).then(res => {
      console.log("name列表", res);
      that.nameList = res.data;
    });
  }
};
</script>

<style lang="less">
.financeManage-transactionHold-page {
  width: 100%;
  height: 500px;
  .hasBottomLine {
    width: 100%;
    padding-bottom: 18px;
    font-size: 18px;
    margin-bottom: 18px;
    font-weight: bold;
    border-bottom: 1px solid #cccccc;
  }

  .header-seach-box {
    width: 100%;
    margin-bottom: 30px;
    display: flex;
    .inputWithSelectBox {
      width: 500px;
      display: flex;
      .el-input-group__prepend {
        .el-select {
          width: 120px;
        }
      }
      .el-input-group__append {
        background: #409eff;
        color: #ffffff;
      }
    }
    .toTransLfet {
      margin-left: 30px;
    }

    .setSelect {
      margin-left: 30px;
      .el-select {
        margin-left: 12px;
      }
    }
  }
  .dialogHeader {
    width: 100%;
    .header-seach-box {
      .setDatePicker {
        padding-right: 20px;
        .setPading {
          padding: 0 12px;
        }
      }
    }
  }
  .table-box {
    width: 100%;
    overflow: hidden;
    .el-table {
      .el-table__header-wrapper {
        .el-table__header {
          text-align: center;
          .cell {
            text-align: center;
          }
        }
      }
      .el-table__body-wrapper {
        .cell {
          text-align: center;
        }
      }
    }
  }

  .footer-box {
    padding: 20px 20px 50px 0px;
  }
  .configItem {
    margin-bottom: 50px;
    padding-bottom: 30px;
    border-bottom: 1px solid #cccccc;
    .item-title {
      font-size: 18px;
      font-weight: bold;
      margin-bottom: 18px;
      display: flex;
      align-items: center;
      .el-button {
        margin-left: 50px;
      }
    }
    .item-action {
      display: flex;
      .desc-box {
        margin-right: 30px;
        .imitateInput {
          min-width: 60px;
          padding: 12px 20px;
          display: inline-block;
          text-align: center;
          border: 1px solid #cccccc;
          margin: 0 12px 0;
        }
      }

      .el-switch.is-disabled {
        opacity: 1;
      }
      .el-switch .is-disabled .el-switch__core,
      .el-switch.is-disabled .el-switch__label {
        cursor: pointer;
      }

      .el-switch.is-disabled .el-switch__core,
      .el-switch.is-disabled .el-switch__label {
        cursor: pointer;
      }
    }
    .item-remark {
      color: #ff8839;
      padding: 1px 0 22px 0;
    }
  }
}
</style>
